import { useCallback, useState } from 'react';

// Single, page-wide feedback channel for Program Settings. Replaces the mix of
// inline success `Alert`s and the modal "Save Successful" dialog with one
// transient, non-blocking snackbar so success feedback is consistent and always
// visible regardless of scroll position.
const useSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');

  const showSnackbar = useCallback((nextMessage, nextSeverity = 'success') => {
    setMessage(nextMessage);
    setSeverity(nextSeverity);
    setOpen(true);
  }, []);

  const closeSnackbar = useCallback((event, reason) => {
    // Keep the snackbar open on stray click-away so a click elsewhere on the
    // page does not dismiss it before the auto-hide timeout.
    if (reason === 'clickaway') return;
    setOpen(false);
  }, []);

  return {
    snackbarOpen: open,
    snackbarMessage: message,
    snackbarSeverity: severity,
    showSnackbar,
    closeSnackbar,
  };
};

export default useSnackbar;
